// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { ReturnOrderLineItemsTable } from '@/return-order/components/return-order-line-items-table';
import { useReturnOrder } from '@/return-order/hooks/use-return-order';
import { useShipments } from '@/shipment/hooks/use-shipments';
import { Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/return-orders/$returnOrderKey/')({
  component: ReturnOrderLineItemsTab,
});

function ReturnOrderLineItemsTab() {
  const { returnOrderKey } = Route.useParams();
  const { returnOrder } = useReturnOrder(returnOrderKey);
  const { shipments } = useShipments({
    filter: { roNumbers: [returnOrder.returnOrderNumber] },
  });

  return (
    <HardfinTabCardWrapper title="Line items">
      <Box paddingY={2}>
        <ReturnOrderLineItemsTable
          items={returnOrder.items}
          shipments={shipments}
        />
      </Box>
    </HardfinTabCardWrapper>
  );
}
